import classNames from "classnames"
import React from "react"
import style from "./style.scss"

interface HamburgerProps {}

const Hamburger: React.SFC<Readonly<HamburgerProps>> = (props) => {
  return (
    <div className={style.hamburger}>
      <span className={classNames(style.line, style["line--top"])} />
      <span className={classNames(style.line, style["line--center"])} />
      <span className={classNames(style.line, style["line--bottom"])} />
    </div>
  )
}

export default Hamburger
